import rabbit = require("crypto-js/rabbit");
import utf8 = require("crypto-js/enc-utf8");
import authModule from "../../../../utilities/AuthModule";

export const localStorageKeys = {
    pinnedItems: "pinnedItems",
    recentItems: "recentItems",
    recentItemsGraph: "recentItemsGraph",
    sharedItems: "sharedItems",
    sites: "sites",
    teams: "teams",
    searchHistory: "searchHistory",
    previousTeamsLocation: "previousTeamsLocation",
    selectedAdvSearchSites: "selectedAdvSearchSites"
};

const getUniqueKey = (key: string): string | null => {
    try {
        const accountId: string = authModule.getPersistedAuthState()?.account?.accountId;
        if (accountId) {
            return key + "." + accountId;
        }
    } catch (error) {
    }
    return null;
}

export const getLocalStorage = (key: string) => {
    try {
        const uniqueKey: string | null = getUniqueKey(key);
        if (uniqueKey) {
            const storage = localStorage.getItem(uniqueKey);
            return JSON.parse(rabbit.decrypt(storage, authModule.getCypherSecret()).toString(utf8));
        }
    } catch (error) {
    }
    return undefined;
}

export const setLocalStorage = (key: string, data: any): boolean => {
    try {
        const uniqueKey: string | null = getUniqueKey(key);
        if (uniqueKey) {
            const storage: string = rabbit.encrypt(JSON.stringify(data), authModule.getCypherSecret()).toString();
            localStorage.setItem(uniqueKey, storage);
            return true;
        }
    } catch (error) {
    }
    return false;
}

export const removeLocalStorage = (key: string) => {
    try {
        localStorage.removeItem(getUniqueKey(key));
    } catch (error) {
    }
}

export const clearLocalStorage = () => {
    try {
        localStorage.clear();
    } catch (error) {
    }
}